import { Resource, ResourceCard, ResourceObject } from '../types';

import {
  documentLinksStatic,
  userGuideStatic,
  videoLinksStatic,
} from '../constants';

export function generateResourceCard(
  content: Map<string, Pick<Resource, 'name' | 'description'>>,
  extraContent: Partial<ResourceCard>,
) {
  const resourceCards = [];
  for (const key of content.keys()) {
    const currentContent = content.get(key);
    if (currentContent) {
      resourceCards.push({
        ...extraContent,
        description: currentContent.description,
        name: currentContent.name,
      });
    }
  }
  return resourceCards as ResourceCard[];
}

export function generateResourceCards(resources: Resource[]): ResourceObject {
  if (!resources.length) {
    return {} as ResourceObject;
  }
  const userGuide = resources
    .filter((resource) => resource.type_of_content === 'User Guide')
    .reduce((acc, r) => {
      if (!Object.keys(r)) {
        return acc;
      }
      Object.assign(acc, { ...r, ...userGuideStatic(false, 'resource-page__') });
      return acc;
    }, {} as ResourceCard);

  const videos: ResourceCard[] = resources
    .filter((resource) => resource.type_of_content === 'How-To Video')
    .map((r) => ({ ...r, ...videoLinksStatic(false, 'resource-videos__') }));

  const documents: ResourceCard[] = resources
    .filter((resource) => resource.type_of_content === 'Quick Reference Guide')
    .map((r) => ({
      ...r,
      ...documentLinksStatic(false, 'resource-documents__'),
    }));


  return {
    documents,
    userGuide,
    videos,
  };
}
